import React from "react";
import SEOPage from "../Components/SEOPage";
import Navbar from "../Components/Navbar";
import ScrollReveal from "../Components/ScrollReveal";
import SiteFooter from "../Components/SiteFooter";
import Chatbox from "../Components/Chatbox";
import AboutHero from "../Components/about/AboutHero";
import AboutStory from "../Components/about/AboutStory";
import AboutValues from "../Components/about/AboutValues";

// Redesigned (Tailwind) page for /about-us.
const AboutPage = () => (
  <div>
    <SEOPage
      title="About DataMetricks Consulting Pvt Ltd | Web & Mobile Development Company in Noida"
      description="DataMetricks is a passionate team of developers, designers and problem solvers in Noida, helping businesses grow with modern web and mobile solutions."
      canonicalUrl="https://www.datametricks.com/about-us"
    />

    <Navbar />
    <ScrollReveal />

    {/* Every Tailwind utility is scoped to `.tw` (see tailwind.config.js) */}
    <main className="tw">
      <AboutHero />
      <AboutStory />
      <AboutValues />
    </main>

    <Chatbox />
    <SiteFooter />
  </div>
);

export default AboutPage;
